import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';
import { UserProfileTabs } from './user-profile-tabs';

export const MESSAGES_PAGE_SIZE = 20;

UserInteractionsMaterialController.$inject = ['$mdDialog', '$scope', '$stateParams', '$rootScope', 'UserFactory',
  'ExternalUserFactory', 'AlertingFactory', 'StrategiesFactory', 'SiteFilterHelperFactory',
  'loggedUser', 'sites', 'openedFromTaskId', 'CrmFactory',
  'selectedOrgId', 'siteId', 'userId', 'avatarUrl', 'linkedUsersAnCrmfOrgs', 'userOptins', '$timeout'];
export function UserInteractionsMaterialController($mdDialog, $scope, $stateParams, $rootScope, UserFactory,
  ExternalUserFactory, AlertingFactory, StrategiesFactory, SiteFilterHelperFactory,
  loggedUser, sites, openedFromTaskId, CrmFactory,
  selectedOrgId, siteId, userId, avatarUrl, linkedUsersAnCrmfOrgs, userOptins, $timeout) {

  $scope.close = close;
  $scope.onTabSelected = onTabSelected;

  $scope.linkCrmContact = linkCrmContact;
  $scope.unlinkCrmContact = unlinkCrmContact;

  $scope.editGroupName = editGroupName;
  $scope.saveGroupName = saveGroupName;
  $scope.cancelGroupNameEdition = cancelGroupNameEdition;
  $scope.saveIsVip = saveIsVip;

  init();

  function editGroupName() {
    $scope.ctx.newGroupName = $scope.ctx.groupName;
    $scope.isGroupNameEdition = true;
  }

  function saveGroupName() {
    $scope.ctx.groupName = $scope.ctx.newGroupName;
    $scope.isGroupNameEdition = false;
    ExternalUserFactory.setGroupName($stateParams.companyId, siteId, userId, $scope.ctx.newGroupName)
      .then(() => AlertingFactory.success('save-ok'),
        AlertingFactory.httpErrorHandler());
  }

  function cancelGroupNameEdition() {
    $scope.isGroupNameEdition = false;
  }

  function saveIsVip() {
    const data = {
      'action_type': $scope.ctx.isVip ? 'tag_vip' : 'untag_vip',
      'task_id': openedFromTaskId,
      'site_id': siteId
    };
    ExternalUserFactory.userAction($stateParams.companyId, userId, data, false)
      .then(() => AlertingFactory.success('save-ok'),
        response => {
          const message = response.data.error_translation ? response.data.error_translation
            : ($translate.instant('error') + ' ' + response.status);
          AlertingFactory.error(message);
        });
  }


  function close() {
    $mdDialog.hide('close');
  }

  function onTabSelected(tab) {
    if (!tab.isActive()) {
      $scope.ctx.userProfileTabs.onTabSelected(tab);
    }
  }

  function linkCrmContact(organizationId, crmContact) {
    $scope.loading = true;

    CrmFactory.setLinkedContact($stateParams.companyId, userId, organizationId, crmContact)
      // Backend might have detected that CRM user was already linked with another Alcmeon user
      // and have merged them. So reload linked users to display the new group users,
      .then(() => reloadLinkedUsers(organizationId, true),
        (response) => CrmFactory.handleCrmErrors(response))
      .finally(() => $scope.loading = false);

  }


  function reloadLinkedUsers(organizationId, isLinked) {
    return ExternalUserFactory.getLinkedUsersAndCrmOrgs($stateParams.companyId, siteId, userId)
      .then(response => {
        $scope.ctx.updateGroupContext(response.data);
        // Activate tab *after* the dom has loaded, otherwise first tab will always be activated
        $timeout(() => {
          $scope.ctx.userProfileTabs.activateTabForOrganisation(organizationId);
        }, 0)
      },
        () => AlertingFactory.error('task_template/see_profile_fail'));
  }


  function unlinkCrmContact(organizationId) {
    $scope.loading = true;

    CrmFactory.unsetLinkedContact($stateParams.companyId, userId, organizationId)
      .then(() => reloadLinkedUsers(organizationId, false),
        (response) => CrmFactory.handleCrmErrors(response))
      .finally(() => $scope.loading = false);
  }


  function init() {
    $scope.companyId = $stateParams.companyId;
    $scope.siteId = siteId;
    $scope.userId = userId;
    $scope.avatarUrl = avatarUrl;
    $scope.openedFromTaskId = openedFromTaskId;
    $scope.canTagVip = UserFactory.hasCapability(siteId, CapabilityIdEnum.TagVIP);
    const filteredSites = SiteFilterHelperFactory.filterSitesThatHaveCapability(sites, loggedUser, CapabilityIdEnum.Answer);
    SiteFilterHelperFactory.addSortKeysAndSort(filteredSites);
    const siteTypeOrder = StrategiesFactory.getOrderedSiteTypeStrings();
    $scope.ctx = new LinkedDataContext(ExternalUserFactory, CrmFactory, AlertingFactory, siteTypeOrder, $stateParams.companyId, filteredSites, userId);
    $scope.ctx.updateGroupContext(linkedUsersAnCrmfOrgs);
    if (selectedOrgId) {
      $scope.ctx.userProfileTabs.activateTabForOrganisation(selectedOrgId);
    } else {
      $scope.ctx.userProfileTabs.activateTabForUser(userId);
    }

    $scope.userOptins = userOptins

  }
}

/* A helper class so that the various classes below have a manageable amount of parameters for their constructor */
class LinkedDataContext {

  constructor(ExternalUserFactory, CrmFactory, AlertingFactory, siteTypeOrder, companyId, sites, clickedUserId) {

    this.ExternalUserFactory = ExternalUserFactory;
    this.CrmFactory = CrmFactory;
    this.AlertingFactory = AlertingFactory;
    this.siteTypeOrder = siteTypeOrder;

    this.companyId = companyId;
    this.sites = sites;

    // User id for which we click on "see profile" or on crm icon
    this.clickedUserId = clickedUserId;
  }

  updateGroupContext(linkedUsersAnCrmfOrgs) {
    this.groupId = linkedUsersAnCrmfOrgs.group_id;
    this.groupName = linkedUsersAnCrmfOrgs.group_name;
    this.isVip = linkedUsersAnCrmfOrgs.is_vip;
    this.organizations = linkedUsersAnCrmfOrgs.sfOrgs;
    this.userProfileTabs = new UserProfileTabs(this.sites, linkedUsersAnCrmfOrgs, this.siteTypeOrder, this);
    this.crmTabs = this.userProfileTabs.crmTabs();
  }

  /* called by the site tabs to load their data */
  loadSiteLinkedData(linkedUser) {
    return this.ExternalUserFactory.getUserInteractions(this.companyId, linkedUser.site_id, linkedUser.user_id, MESSAGES_PAGE_SIZE)
      .then(response => response.data,
        () => this.AlertingFactory.errorAndReturnRejectedPromise('task_template/see_profile_fail'));
  }

  /* called by the CRM tabs to load their data */
  loadCrmLinkedData(organization) {
    return this.CrmFactory.getLinkedContact(this.companyId, this.clickedUserId, organization.id)
      .then(response => response.data,
        (response) => this.CrmFactory.handleCrmErrors(response, 'task_template/see_profile_fail'));
  }

}